
export const GET_LOCATION = 'GET_LOCATION';

